import React from "react";
import { connect } from "react-redux";
import { goTo } from "../tools";
import { servicios } from "./../properties";
import firebase from 'firebase';
import ModalOpcionesAyuda from "../../src/modal-ayuda/modal-opciones-ayuda.cmpt";
import BtnAyuda from "../gnp-registro/btn-ayuda.cmpt";
import MensajeAyuda from "../modal-ayuda-registro/modal-ayuda-registro.cmpt";

const mapState = (state) => {
	return {
		paso: state.registro.paso,
		"dispositivo": state.global.dispositivo,
		showAviso: state.registro.showAviso
	};
};

class Paso extends React.Component {
	state = {
		"images": [
			require("../img/icon-registro-poliza.svg"),
			require("../img/icon-registro-datos.svg"),
			require("../img/icon-registro-seguridad.svg")
		],
		"imageneWebviews": [
			require("../img/Stepper1@2x.svg"),
			require("../img/Stepper2@2x.svg"),
			require("../img/Stepper3@2x.svg")
		],
		"titulo": [
			"Datos de Póliza",
			"Datos Personales",
			"Datos Seguridad"
		],
		contador: 0,
		btnAyuda: false,
		showModalAyuda: false,
        tipoModalAyuda: ""
	}

	cancelar = () => {
		const btnAyuda = localStorage.getItem("btnAyuda");

		if(btnAyuda !== undefined && btnAyuda === "true"){
			this.setState({ showModalAyuda: true, tipoModalAyuda: "regresar"});
		} else {
			this.setState({ showModalAyuda: false, tipoModalAyuda: ""});
			this.regresar();
		}
	}

	regresar = () => {
		localStorage.removeItem("aceptarAviso");
		localStorage.removeItem("mediosElectronicos");
		localStorage.removeItem("mensajeAyuda");

		firebase.database().ref("portales/portalReingenieria").once("value").then(oValue => {
			const data = oValue.val();
			if (!data) {
				goTo("login");
			} else {
				window.location.assign(servicios.dominioReingenieria);
			}
		})
	}
	
	cierraTooltip2 = () => {
        this.setState({
            showModalAyuda: !this.state.showModalAyuda 
        });
    }
	
	render() {
		return (
			<div>
				{this.props.paso < 3 &&
					<div>
						{
							<div>
								{this.props.dispositivo === "web" ?
									<div className="txt-center">
										<div id="title-Registro">
											<span className="material-icons bi bi-arrow-left" style={{ float: "left", cursor: "pointer", marginTop: "20px" }} onClick={this.cancelar.bind(this)}>
												arrow_back
											</span>
											<h3 id="txt-Registro">Registro</h3>
											<br />
											<hr className="label-hr" />
										</div>
									</div> :
									this.props.showAviso === false &&
									<div className="txt-center">
										<img src={this.state.imageneWebviews[this.props.paso]} className="pasos-img" alt="step-registro" />
									</div>
								}

								{this.props.dispositivo === "web" ?
									<div style={{ "display": "none" }}>
										{this.state.images.map((item, i) => <img src={item} key={i} />)}
									</div> :
									<div style={{ "display": "none" }}>
										{this.state.imageneWebviews.map((item, i) => <img src={item} key={i} />)}
									</div>
								}
							</div>
						}
					</div>
				}
				<MensajeAyuda onClose={this.cierraTooltip2} show={this.state.showModalAyuda} typeModal={this.state.tipoModalAyuda}></MensajeAyuda>

				{<ModalOpcionesAyuda></ModalOpcionesAyuda>}
				{<BtnAyuda></BtnAyuda>}
			</div>
		);
	}
}

export default connect(mapState)(Paso);



// WEBPACK FOOTER //
// ./src/gnp-registro/paso.cmpt.js